module.exports = __webpack_public_path__ + "static/media/29EUNOG20.e52a3e1d.jpg";